import type { BookStatus } from '../../shared/api';
import { STATUS_LABELS } from '../lib/format';

export function StatusBadge({ status }: { status: BookStatus }) {
  return <span className={`badge badge--${status}`}>{STATUS_LABELS[status]}</span>;
}
